import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-sm border px-1.5 py-px text-xs font-semibold uppercase tracking-[0.04em]",
  {
    variants: {
      tone: {
        neutral: "border-line-strong bg-surface-sunken text-fg-muted",
        approve: "border-approve/35 bg-approve/10 text-approve",
        review: "border-review/35 bg-review/10 text-review",
        decline: "border-decline/35 bg-decline/10 text-decline",
        accent: "border-accent/35 bg-accent-soft text-accent",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, tone, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />
}
